'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _PlatformApi2 = require('./PlatformApi');

var _PlatformApi3 = _interopRequireDefault(_PlatformApi2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable sort-keys */
var endpoints = {
  companies: {
    one: '/companies/{record}',
    params: {
      record: 'company_id'
    },
    queryParams: ['ad_account', 'brand_id', 'currency', 'publisher', 'token_health'],

    adAccounts: {
      one: '/companies/{record}/adaccounts',
      params: {
        record: 'company_id'
      },
      queryParams: ['ad_account', 'brand_id', 'currency', 'limit', 'offset', 'order_by', 'publisher', 'token_health']
    }
  }
  /* eslint-enable sort-keys */

};var defaultOptions = {
  prefix: '/contexting'
};

var ContextingApi = function (_PlatformApi) {
  (0, _inherits3.default)(ContextingApi, _PlatformApi);

  function ContextingApi(options) {
    (0, _classCallCheck3.default)(this, ContextingApi);

    var o = (0, _assign2.default)({}, defaultOptions, options);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ContextingApi.__proto__ || (0, _getPrototypeOf2.default)(ContextingApi)).call(this, o));

    _this._endpoints = endpoints;
    return _this;
  }

  return ContextingApi;
}(_PlatformApi3.default);

exports.default = ContextingApi;
//# sourceMappingURL=ContextingApi.js.map